import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3a9499b0")

_pushScopeId("data-v-3a9499b0")
const _hoisted_1 = {
  key: 0,
  class: "container popup-container"
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "profile-title" }
const _hoisted_4 = { class: "profile-content" }
const _hoisted_5 = { class: "profile-block" }
const _hoisted_6 = { class: "profile-block-title" }
const _hoisted_7 = { class: "profile-block-data" }
const _hoisted_8 = { class: "profile-data-name" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_10 = { class: "profile-block" }
const _hoisted_11 = { class: "profile-block-title" }
const _hoisted_12 = { class: "profile-block-data" }
const _hoisted_13 = { class: "check-item" }
const _hoisted_14 = {
  class: "cbx w-100",
  for: "ReportsView",
  tabindex: "12"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_16 = { class: "checkboxtext col-10" }
const _hoisted_17 = { class: "profile-block" }
const _hoisted_18 = { class: "profile-block-title" }
const _hoisted_19 = { class: "profile-block-data" }
const _hoisted_20 = { class: "check-item" }
const _hoisted_21 = {
  class: "cbx w-100",
  for: "CreateOrders",
  tabindex: "12"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_23 = { class: "checkboxtext col-10" }
const _hoisted_24 = { class: "check-item" }
const _hoisted_25 = {
  class: "cbx w-100",
  for: "ViewOrders",
  tabindex: "12"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_27 = { class: "checkboxtext col-10" }
const _hoisted_28 = { class: "check-item" }
const _hoisted_29 = {
  class: "cbx w-100",
  for: "EditOrders",
  tabindex: "12"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_31 = { class: "checkboxtext col-10" }
const _hoisted_32 = { class: "check-item" }
const _hoisted_33 = {
  class: "cbx w-100",
  for: "ChangeOrderStatus",
  tabindex: "12"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_35 = { class: "checkboxtext col-10" }
const _hoisted_36 = { class: "check-item" }
const _hoisted_37 = {
  class: "cbx w-100",
  for: "changeUnitPrice",
  tabindex: "12"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_39 = { class: "checkboxtext col-10" }
const _hoisted_40 = { class: "check-item" }
const _hoisted_41 = {
  class: "cbx w-100",
  for: "CreateReceipts",
  tabindex: "12"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_43 = { class: "checkboxtext col-10" }
const _hoisted_44 = { class: "check-item" }
const _hoisted_45 = {
  class: "cbx w-100",
  for: "CreateInvoices",
  tabindex: "12"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_47 = { class: "checkboxtext col-10" }
const _hoisted_48 = { class: "check-item" }
const _hoisted_49 = {
  class: "cbx w-100",
  for: "CreateCreditInvoices",
  tabindex: "12"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_51 = { class: "checkboxtext col-10" }
const _hoisted_52 = { class: "check-item" }
const _hoisted_53 = {
  class: "cbx w-100",
  for: "CreatePerfomaInvoices",
  tabindex: "12"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_55 = { class: "checkboxtext col-10" }
const _hoisted_56 = { class: "check-item" }
const _hoisted_57 = {
  class: "cbx w-100",
  for: "GenerateLinkOfPersonalAreaToOrder",
  tabindex: "12"
}
const _hoisted_58 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_59 = { class: "checkboxtext col-10" }
const _hoisted_60 = { class: "check-item" }
const _hoisted_61 = {
  class: "cbx w-100",
  for: "CreateChangeOrderInPast",
  tabindex: "12"
}
const _hoisted_62 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_63 = { class: "checkboxtext col-10" }
const _hoisted_64 = { class: "check-item" }
const _hoisted_65 = {
  class: "cbx w-100",
  for: "CreateChangeSlotInPast",
  tabindex: "12"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_67 = { class: "checkboxtext col-10" }
const _hoisted_68 = { class: "profile-block" }
const _hoisted_69 = { class: "profile-block-title" }
const _hoisted_70 = { class: "profile-block-data" }
const _hoisted_71 = { class: "check-item" }
const _hoisted_72 = {
  class: "cbx w-100",
  for: "ProductsViewSearch",
  tabindex: "12"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_74 = { class: "checkboxtext col-10" }
const _hoisted_75 = { class: "check-item" }
const _hoisted_76 = {
  class: "cbx w-100",
  for: "EditProducts",
  tabindex: "12"
}
const _hoisted_77 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_78 = { class: "checkboxtext col-10" }
const _hoisted_79 = { class: "check-item" }
const _hoisted_80 = {
  class: "cbx w-100",
  for: "CreateProducts",
  tabindex: "12"
}
const _hoisted_81 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_82 = { class: "checkboxtext col-10" }
const _hoisted_83 = { class: "profile-block" }
const _hoisted_84 = { class: "profile-block-title" }
const _hoisted_85 = { class: "profile-block-data" }
const _hoisted_86 = { class: "check-item" }
const _hoisted_87 = {
  class: "cbx w-100",
  for: "DocumentViewSearch",
  tabindex: "12"
}
const _hoisted_88 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_89 = { class: "checkboxtext col-10" }
const _hoisted_90 = { class: "check-item" }
const _hoisted_91 = {
  class: "cbx w-100",
  for: "DocumentShare",
  tabindex: "12"
}
const _hoisted_92 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_93 = { class: "checkboxtext col-10" }
const _hoisted_94 = { class: "check-item" }
const _hoisted_95 = {
  class: "cbx w-100",
  for: "CreateBulkInvoices",
  tabindex: "12"
}
const _hoisted_96 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_97 = { class: "checkboxtext col-10" }
const _hoisted_98 = { class: "profile-block" }
const _hoisted_99 = { class: "profile-block-title" }
const _hoisted_100 = { class: "profile-block-data" }
const _hoisted_101 = { class: "check-item" }
const _hoisted_102 = {
  class: "cbx w-100",
  for: "CalendarViewFilter",
  tabindex: "12"
}
const _hoisted_103 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_104 = { class: "checkboxtext col-10" }
const _hoisted_105 = { class: "check-item" }
const _hoisted_106 = {
  class: "cbx w-100",
  for: "CalendarStopSale",
  tabindex: "12"
}
const _hoisted_107 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_108 = { class: "checkboxtext col-10" }
const _hoisted_109 = { class: "profile-block" }
const _hoisted_110 = { class: "profile-block-title" }
const _hoisted_111 = { class: "profile-block-data" }
const _hoisted_112 = { class: "check-item" }
const _hoisted_113 = {
  class: "cbx w-100",
  for: "ViewProviderSettings",
  tabindex: "12"
}
const _hoisted_114 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_115 = { class: "checkboxtext col-10" }
const _hoisted_116 = { class: "check-item" }
const _hoisted_117 = {
  class: "cbx w-100",
  for: "EditProviderSettings",
  tabindex: "12"
}
const _hoisted_118 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_119 = { class: "checkboxtext col-10" }
const _hoisted_120 = { class: "profile-block" }
const _hoisted_121 = { class: "profile-block-title" }
const _hoisted_122 = { class: "profile-block-data" }
const _hoisted_123 = { class: "check-item" }
const _hoisted_124 = {
  class: "cbx w-100",
  for: "CouponCanChange",
  tabindex: "12"
}
const _hoisted_125 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_126 = { class: "checkboxtext col-10" }
const _hoisted_127 = { class: "profile-block" }
const _hoisted_128 = { class: "profile-block-title" }
const _hoisted_129 = { class: "profile-block-data" }
const _hoisted_130 = { class: "check-item" }
const _hoisted_131 = {
  class: "cbx w-100",
  for: "cashier",
  tabindex: "12"
}
const _hoisted_132 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_133 = { class: "checkboxtext col-10" }
const _hoisted_134 = { class: "white-block row" }
const _hoisted_135 = { class: "white-block-title col-12" }
const _hoisted_136 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_137 = { class: "checkboxtext col-10" }
const _hoisted_138 = { class: "white-block row" }
const _hoisted_139 = { class: "white-block-title col-12" }
const _hoisted_140 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_141 = { class: "checkboxtext col-10" }
const _hoisted_142 = { class: "white-block row" }
const _hoisted_143 = { class: "white-block-title col-12" }
const _hoisted_144 = { class: "col-12 col-md-6" }
const _hoisted_145 = {
  class: "cbx w-100",
  for: "CashierSellToPrivate",
  tabindex: "12"
}
const _hoisted_146 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_147 = { class: "checkboxtext col-10" }
const _hoisted_148 = { class: "col-12 col-md-6" }
const _hoisted_149 = {
  class: "cbx w-100",
  for: "CashierSellToBusiness",
  tabindex: "12"
}
const _hoisted_150 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_151 = { class: "checkboxtext col-10" }
const _hoisted_152 = { class: "profile-block-data" }
const _hoisted_153 = { class: "check-item" }
const _hoisted_154 = {
  class: "cbx w-100",
  for: "cashier-reservedOrders",
  tabindex: "12"
}
const _hoisted_155 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_156 = { class: "checkboxtext col-10" }
const _hoisted_157 = { class: "check-item" }
const _hoisted_158 = {
  class: "cbx w-100",
  for: "cashier-clubsVouchers",
  tabindex: "12"
}
const _hoisted_159 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_160 = { class: "checkboxtext col-10" }
const _hoisted_161 = { class: "check-item" }
const _hoisted_162 = {
  class: "cbx w-100",
  for: "cashier-cashierChangeRate",
  tabindex: "12"
}
const _hoisted_163 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_164 = { class: "checkboxtext col-10" }
const _hoisted_165 = { class: "check-item" }
const _hoisted_166 = {
  class: "cbx w-100",
  for: "cashier-cashierEditSlot",
  tabindex: "12"
}
const _hoisted_167 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_168 = { class: "checkboxtext col-10" }
const _hoisted_169 = { class: "check-item" }
const _hoisted_170 = {
  class: "cbx w-100",
  for: "cashier-cashierChangeDiscount",
  tabindex: "12"
}
const _hoisted_171 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_172 = { class: "checkboxtext col-10" }
const _hoisted_173 = {
  key: 0,
  class: "check-item",
  style: {"display":"flex","grid-column-gap":"20px","align-items":"center"}
}
const _hoisted_174 = {
  class: "pl-10",
  style: {"font-size":"14px","color":"#000000"}
}
const _hoisted_175 = { class: "check-item" }
const _hoisted_176 = {
  class: "cbx w-100",
  for: "cashier-cashierMaxChecks",
  tabindex: "12"
}
const _hoisted_177 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_178 = { class: "checkboxtext col-10" }
const _hoisted_179 = {
  key: 1,
  class: "check-item",
  style: {"display":"flex","grid-column-gap":"20px","align-items":"center"}
}
const _hoisted_180 = {
  class: "pl-10",
  style: {"font-size":"14px","color":"#000000"}
}
const _hoisted_181 = { class: "profile-edit-footer" }
const _hoisted_182 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-save fs-20 d-block" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputNumber = _resolveComponent("InputNumber")

  return (_ctx.loaded)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.id > 0 ? _ctx.$t('provider.edit-profile') : _ctx.$t('provider.create-profile')), 1),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('provider.profile-name')), 1),
              _createVNode("div", _hoisted_7, [
                _createVNode("label", _hoisted_8, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('provider.profile-name')), 1),
                  _hoisted_9
                ]),
                _withDirectives(_createVNode("input", {
                  class: "profile-data-name-input",
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.profile.description = $event))
                }, null, 512), [
                  [_vModelText, _ctx.profile.description]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('title.reports')), 1),
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "ReportsView",
                    value: _ctx.permissions.ReportsView,
                    id: "ReportsView",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_14, [
                    _hoisted_15,
                    _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('permission.reports-view')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('title.orders')), 1),
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CreateOrders",
                    value: _ctx.permissions.CreateOrders,
                    id: "CreateOrders",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_21, [
                    _hoisted_22,
                    _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('permission.create-orders')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_24, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "ViewOrders",
                    value: _ctx.permissions.ViewOrders,
                    id: "ViewOrders",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_25, [
                    _hoisted_26,
                    _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('permission.view-orders')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_28, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "EditOrders",
                    value: _ctx.permissions.EditOrders,
                    id: "EditOrders",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_29, [
                    _hoisted_30,
                    _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('permission.edit-orders')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_32, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "ChangeOrderStatus",
                    value: _ctx.permissions.ChangeOrderStatus,
                    id: "ChangeOrderStatus",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_33, [
                    _hoisted_34,
                    _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('permission.change-order-status')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_36, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "changeUnitPrice",
                    value: _ctx.permissions.ChangeUnitPrice,
                    id: "changeUnitPrice",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_37, [
                    _hoisted_38,
                    _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('permission.edit-unitPrice')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_40, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CreateReceipts",
                    value: _ctx.permissions.CreateReceipts,
                    id: "CreateReceipts",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_41, [
                    _hoisted_42,
                    _createVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('permission.create-receipts')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_44, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CreateInvoices",
                    value: _ctx.permissions.CreateInvoices,
                    id: "CreateInvoices",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_45, [
                    _hoisted_46,
                    _createVNode("span", _hoisted_47, _toDisplayString(_ctx.$t('permission.create-invoices')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_48, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CreateCreditInvoices",
                    value: _ctx.permissions.CreateCreditInvoices,
                    id: "CreateCreditInvoices",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_49, [
                    _hoisted_50,
                    _createVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('permission.create-credit-invoices')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_52, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CreatePerfomaInvoices",
                    value: _ctx.permissions.CreatePerfomaInvoices,
                    id: "CreatePerfomaInvoices",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_53, [
                    _hoisted_54,
                    _createVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('permission.create-perfoma-invoices')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_56, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "GenerateLinkOfPersonalAreaToOrder",
                    value: _ctx.permissions.GenerateLinkOfPersonalAreaToOrder,
                    id: "GenerateLinkOfPersonalAreaToOrder",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_57, [
                    _hoisted_58,
                    _createVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('permission.generate-link-of-personal-area-to-order')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_60, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CreateChangeOrderInPast",
                    value: _ctx.permissions.CreateChangeOrderInPast,
                    id: "CreateChangeOrderInPast",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_61, [
                    _hoisted_62,
                    _createVNode("span", _hoisted_63, _toDisplayString(_ctx.$t('permission.create-order-in-past')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_64, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CreateChangeSlotInPast",
                    value: _ctx.permissions.CreateChangeSlotInPast,
                    id: "CreateChangeSlotInPast",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_65, [
                    _hoisted_66,
                    _createVNode("span", _hoisted_67, _toDisplayString(_ctx.$t('permission.create-slot-in-past')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_68, [
              _createVNode("div", _hoisted_69, _toDisplayString(_ctx.$t('title.products')), 1),
              _createVNode("div", _hoisted_70, [
                _createVNode("div", _hoisted_71, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "ProductsViewSearch",
                    value: _ctx.permissions.ProductsViewSearch,
                    id: "ProductsViewSearch",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_72, [
                    _hoisted_73,
                    _createVNode("span", _hoisted_74, _toDisplayString(_ctx.$t('permission.view-products')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_75, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "EditProducts",
                    value: _ctx.permissions.EditProducts,
                    id: "EditProducts",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_76, [
                    _hoisted_77,
                    _createVNode("span", _hoisted_78, _toDisplayString(_ctx.$t('permission.edit-products')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_79, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CreateProducts",
                    value: _ctx.permissions.CreateProducts,
                    id: "CreateProducts",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_80, [
                    _hoisted_81,
                    _createVNode("span", _hoisted_82, _toDisplayString(_ctx.$t('permission.create-products')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_83, [
              _createVNode("div", _hoisted_84, _toDisplayString(_ctx.$t('title.document')), 1),
              _createVNode("div", _hoisted_85, [
                _createVNode("div", _hoisted_86, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "DocumentViewSearch",
                    value: _ctx.permissions.DocumentViewSearch,
                    id: "DocumentViewSearch",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_87, [
                    _hoisted_88,
                    _createVNode("span", _hoisted_89, _toDisplayString(_ctx.$t('permission.document-view-search')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_90, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "DocumentShare",
                    value: _ctx.permissions.DocumentShare,
                    id: "DocumentShare",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_91, [
                    _hoisted_92,
                    _createVNode("span", _hoisted_93, _toDisplayString(_ctx.$t('permission.document-share')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_94, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CreateBulkInvoices",
                    value: _ctx.permissions.CreateBulkInvoices,
                    id: "CreateBulkInvoices",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_95, [
                    _hoisted_96,
                    _createVNode("span", _hoisted_97, _toDisplayString(_ctx.$t('permission.create-bulk-invoices')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_98, [
              _createVNode("div", _hoisted_99, _toDisplayString(_ctx.$t('title.calendar')), 1),
              _createVNode("div", _hoisted_100, [
                _createVNode("div", _hoisted_101, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CalendarViewFilter",
                    value: _ctx.permissions.CalendarViewFilter,
                    id: "CalendarViewFilter",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_102, [
                    _hoisted_103,
                    _createVNode("span", _hoisted_104, _toDisplayString(_ctx.$t('permission.calendar-view-filter')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_105, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CalendarStopSale",
                    value: _ctx.permissions.CalendarStopSale,
                    id: "CalendarStopSale",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_106, [
                    _hoisted_107,
                    _createVNode("span", _hoisted_108, _toDisplayString(_ctx.$t('permission.calendar-stop-sale')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_109, [
              _createVNode("div", _hoisted_110, _toDisplayString(_ctx.$t('title.provider')), 1),
              _createVNode("div", _hoisted_111, [
                _createVNode("div", _hoisted_112, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "ViewProviderSettings",
                    value: _ctx.permissions.ViewProviderSettings,
                    id: "ViewProviderSettings",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_113, [
                    _hoisted_114,
                    _createVNode("span", _hoisted_115, _toDisplayString(_ctx.$t('permission.provider-view-settings')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_116, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "EditProviderSettings",
                    value: _ctx.permissions.EditProviderSettings,
                    id: "EditProviderSettings",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_117, [
                    _hoisted_118,
                    _createVNode("span", _hoisted_119, _toDisplayString(_ctx.$t('permission.provider-edit-settings')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_120, [
              _createVNode("div", _hoisted_121, _toDisplayString(_ctx.$t('cashier.label.coupon')), 1),
              _createVNode("div", _hoisted_122, [
                _createVNode("div", _hoisted_123, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CouponCanChange",
                    value: _ctx.permissions.CouponCanChange,
                    id: "CouponCanChange",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_124, [
                    _hoisted_125,
                    _createVNode("span", _hoisted_126, _toDisplayString(_ctx.$t('coupon.permissions.can-change')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_127, [
              _createVNode("div", _hoisted_128, _toDisplayString(_ctx.$t('title.cashier')), 1),
              _createVNode("div", _hoisted_129, [
                _createVNode("div", _hoisted_130, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "cashier",
                    value: _ctx.permissions.Cashier,
                    id: "cashier",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_131, [
                    _hoisted_132,
                    _createVNode("span", _hoisted_133, _toDisplayString(_ctx.$t('permission.cashier')), 1)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_134, [
                _createVNode("div", _hoisted_135, _toDisplayString(_ctx.$t('permission.products.title')), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "col-12",
                    key: product.id
                  }, [
                    _withDirectives(_createVNode("input", {
                      class: "inp-cbx",
                      name: 'product' + product.id,
                      value: product.id,
                      id: 'product' + product.id,
                      type: "checkbox",
                      style: {"display":"none"},
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.profile.products = $event))
                    }, null, 8, ["name", "value", "id"]), [
                      [_vModelCheckbox, _ctx.profile.products]
                    ]),
                    _createVNode("label", {
                      class: "cbx w-100",
                      for: 'product' + product.id,
                      tabindex: "12"
                    }, [
                      _hoisted_136,
                      _createVNode("span", _hoisted_137, _toDisplayString(product.text), 1)
                    ], 8, ["for"])
                  ]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_138, [
                _createVNode("div", _hoisted_139, _toDisplayString(_ctx.$t('permission.priceTypes.title')), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.priceTypes, (priceType) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "col-12 col-md-6",
                    key: priceType.id
                  }, [
                    _withDirectives(_createVNode("input", {
                      class: "inp-cbx",
                      name: 'priceType' + priceType.id,
                      value: priceType.id,
                      id: 'priceType' + priceType.id,
                      type: "checkbox",
                      style: {"display":"none"},
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.profile.priceTypes = $event))
                    }, null, 8, ["name", "value", "id"]), [
                      [_vModelCheckbox, _ctx.profile.priceTypes]
                    ]),
                    _createVNode("label", {
                      class: "cbx w-100",
                      for: 'priceType' + priceType.id,
                      tabindex: "12"
                    }, [
                      _hoisted_140,
                      _createVNode("span", _hoisted_141, _toDisplayString(priceType.name), 1)
                    ], 8, ["for"])
                  ]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_142, [
                _createVNode("div", _hoisted_143, _toDisplayString(_ctx.$t('permission.clientTypeToSell.title')), 1),
                _createVNode("div", _hoisted_144, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CashierSellToPrivate",
                    value: _ctx.permissions.CashierSellToPrivate,
                    id: "CashierSellToPrivate",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_145, [
                    _hoisted_146,
                    _createVNode("span", _hoisted_147, _toDisplayString(_ctx.$t('permission.cashierSellToPrivate')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_148, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "CashierSellToBusiness",
                    value: _ctx.permissions.CashierSellToBusiness,
                    id: "CashierSellToBusiness",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_149, [
                    _hoisted_150,
                    _createVNode("span", _hoisted_151, _toDisplayString(_ctx.$t('permission.cashierSellToBusiness')), 1)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_152, [
                _createVNode("div", _hoisted_153, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "cashier-reservedOrders",
                    value: _ctx.permissions.CashierReservedOrders,
                    id: "cashier-reservedOrders",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_154, [
                    _hoisted_155,
                    _createVNode("span", _hoisted_156, _toDisplayString(_ctx.$t('permission.cashier-reservedOrders')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_157, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "cashier-clubsVouchers",
                    value: _ctx.permissions.CashierClubsVouchers,
                    id: "cashier-clubsVouchers",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_158, [
                    _hoisted_159,
                    _createVNode("span", _hoisted_160, _toDisplayString(_ctx.$t('permission.cashier-clubsVouchers')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_161, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "cashier-cashierChangeRate",
                    value: _ctx.permissions.CashierChangeRate,
                    id: "cashier-cashierChangeRate",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_162, [
                    _hoisted_163,
                    _createVNode("span", _hoisted_164, _toDisplayString(_ctx.$t('permission.cashier-edit-rate')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_165, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "cashier-cashierEditSlot",
                    value: _ctx.permissions.CashierEditSlot,
                    id: "cashier-cashierEditSlot",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.profile.permissions = $event))
                  }, null, 8, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_166, [
                    _hoisted_167,
                    _createVNode("span", _hoisted_168, _toDisplayString(_ctx.$t('permission.cashier-edit-slot')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_169, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "cashier-cashierChangeDiscount",
                    value: _ctx.permissions.CashierChangeDiscount,
                    id: "cashier-cashierChangeDiscount",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.profile.permissions = $event)),
                    onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.changeCashierMaxDicountPercent($event)))
                  }, null, 40, ["value"]), [
                    [_vModelCheckbox, _ctx.profile.permissions]
                  ]),
                  _createVNode("label", _hoisted_170, [
                    _hoisted_171,
                    _createVNode("span", _hoisted_172, _toDisplayString(_ctx.$t('permission.cashier-edit-discount')), 1)
                  ])
                ]),
                (_ctx.profile.permissions.includes(_ctx.permissions.CashierChangeDiscount))
                  ? (_openBlock(), _createBlock("div", _hoisted_173, [
                      _createVNode("span", _hoisted_174, _toDisplayString(_ctx.$t('maximumDiscountPercentageInfo')), 1),
                      _createVNode(_component_InputNumber, {
                        class: [{ InputNumberWrong: _ctx.wrongCashierMaximumDiscount }, "shortInput"],
                        modelValue: _ctx.profile.cashierMaxDicountPercent,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.profile.cashierMaxDicountPercent = $event)),
                        min: 0,
                        max: 100,
                        allowEmpty: true,
                        suffix: "%"
                      }, null, 8, ["class", "modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_175, [
                  _withDirectives(_createVNode("input", {
                    class: "inp-cbx",
                    name: "cashier-cashierMaxChecks",
                    id: "cashier-cashierMaxChecks",
                    type: "checkbox",
                    style: {"display":"none"},
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.showCashierMaxChecks = $event)),
                    onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.changeCashierMaxChecks($event)))
                  }, null, 544), [
                    [_vModelCheckbox, _ctx.showCashierMaxChecks]
                  ]),
                  _createVNode("label", _hoisted_176, [
                    _hoisted_177,
                    _createVNode("span", _hoisted_178, _toDisplayString(_ctx.$t('permission.cashier-max-checks')), 1)
                  ])
                ]),
                (_ctx.showCashierMaxChecks)
                  ? (_openBlock(), _createBlock("div", _hoisted_179, [
                      _createVNode("span", _hoisted_180, _toDisplayString(_ctx.$t('maximumMaxChecksInfo')), 1),
                      _createVNode(_component_InputNumber, {
                        class: ["shortInput", { InputNumberWrong: _ctx.wrongCashierMaximumChecks }],
                        modelValue: _ctx.profile.cashierMaxChecks,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.profile.cashierMaxChecks = $event)),
                        min: 1,
                        max: 999,
                        allowEmpty: true,
                        required: ""
                      }, null, 8, ["class", "modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_181, [
            _createVNode("button", {
              class: "cancel",
              onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.cancel()))
            }, _toDisplayString(_ctx.$t('button.cancel')), 1),
            _createVNode("button", {
              class: "save",
              onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.save()))
            }, [
              _hoisted_182,
              _createTextVNode(_toDisplayString(_ctx.$t('button.save')), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})